module.exports = __webpack_public_path__ + "whiterocks.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whiterocks.png
// module id = 900
// module chunks = 0